import React,{createContext,useState} from 'react'
import api from '../services/api'
export const UserContext = createContext({})

function UserProvider({children}){

    const [data,setData] = useState([])

    const getByName = async (value) => {
        
        if(value == ""){

            const response = await api.get("user")
            setData(response.data)
            return false
        }

        const response = await api.get(`/user/by/name/${value}`)
        
        if(response.status == 404){
            setData([])
        }

        setData(response.data)
    }


    
    return(
    <UserContext.Provider value={{getByName,data}}>
        {children}
    </UserContext.Provider>
    )

}

export default UserProvider